import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6393b933")

_pushScopeId("data-v-6393b933")
const _hoisted_1 = { class: "selecting-ingredient-list" }
const _hoisted_2 = {
  key: 0,
  class: "selecting-ingredient-list-title"
}
const _hoisted_3 = { class: "selecting-ingredient-list-title-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectingIngredientListItem = _resolveComponent("SelectingIngredientListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.categoryTitle)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.categoryTitle), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ingredientArray, (ingredient) => {
      return (_openBlock(), _createBlock(_component_SelectingIngredientListItem, {
        key: ingredient.id,
        id: ingredient.id,
        imageUrl: ingredient.imageUrl,
        ingredientName: ingredient.name,
        isSelected: ingredient.isSelect,
        isShowButton: ingredient.isShowButton,
        onSelectIngredient: ($event: any) => (_ctx.selectIngredient(ingredient.id, ingredient.name, !ingredient.isSelect)),
        onClickButton: ($event: any) => (_ctx.clickButton(ingredient.id, ingredient.name))
      }, null, 8, ["id", "imageUrl", "ingredientName", "isSelected", "isShowButton", "onSelectIngredient", "onClickButton"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})